import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconTriangle = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke="none"
        strokeWidth={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.90665 5.1687C10.3534 4.44008 11.1484 4 12.0003 4C12.8523 4 13.6473 4.44008 14.094 5.1687L14.0969 5.17346L20.2446 15.3277L20.2528 15.3416C20.6915 16.0932 20.6941 17.0202 20.2597 17.7743C19.8259 18.5272 19.0248 18.9905 18.1589 18.9999L18.148 19.0001L5.84179 19C4.97586 18.9906 4.17473 18.5272 3.74099 17.7743C3.30654 17.0202 3.30918 16.0932 3.74786 15.3416L3.75609 15.3277L9.90665 5.1687ZM11.6127 6.21237L5.47234 16.3546C5.39802 16.4859 5.39853 16.6449 5.47397 16.7759C5.55046 16.9086 5.69564 16.9969 5.85961 17H18.141C18.305 16.9969 18.4502 16.9086 18.5267 16.7759C18.6021 16.6449 18.6026 16.4859 18.5283 16.3547L12.3879 6.21237C12.3081 6.08347 12.1625 6 12.0003 6C11.8381 6 11.6926 6.08347 11.6127 6.21237ZM11 13V9H13V13H11ZM11 14V16H13V14H11Z"
        />
      </svg>
    );
  }
);
